import React from "react";
import Layout from "~/Layout";
import "./requests.scss";
import CustomeButton from "~/components/Button";
import { TabPanel, TabView } from "primereact/tabview";
import { Card } from "primereact/card";
import RequestDataTable from "./components/RequestDataTable";
import useRequest, { REQUEST_TYPES } from "./useRequest";
import NewRequestModal from "./components/new-request-modal/NewRequestModal";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const Requests = ({ requestType }) => {
  const { role } = useSelector((state) => state.login);
  const {
    activeIndex,
    setActiveIndex,
    loading,
    page,
    rows,
    isDataAvailable,
    totalRecords,
    requests,
    onPageChange,
    count,
    showModal,
    setShowModal,
    hideRequestModal,
    refetch,
  } = useRequest(requestType);

  const renderHeader = (label, count) => (
    <span className="flex align-items-center gap-2">
      {label}
      <span className="requests__count">{count}</span>
    </span>
  );

  const renderRequestTabs =
    requestType === REQUEST_TYPES.AD_HOC ? (
      <div className={`${loading ? "disabled" : ""}`}>
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => {
            setActiveIndex(e.index);
          }}
        >
          <TabPanel header={renderHeader("All", count.all)} />
          <TabPanel header={renderHeader("Sent", count.sent)} />
          <TabPanel header={renderHeader("Received", count.received)} />
        </TabView>
      </div>
    ) : null;

  return (
    <Layout
      title={requestType === REQUEST_TYPES.AD_HOC ? "Requests" : "Escalations"}
    >
      <div className="request__container">
        {requestType === REQUEST_TYPES.AD_HOC && (
          <div className="flex w-full flex-row-reverse">
            <CustomeButton
              label={"New Request"}
              className="access-btn"
              variant="contained"
              icon="pi pi-plus"
              iconPos="right"
              onClick={() => setShowModal(true)}
            />
          </div>
        )}
        {["CUSTOMER", "CUSTOMER_MANAGER"].includes(role) &&
          requestType === REQUEST_TYPES.ESCALATION && (
            <div className="flex w-full flex-row-reverse">
              <CustomeButton
                label={"New Escalation"}
                className="access-btn"
                variant="contained"
                icon="pi pi-plus"
                iconPos="right"
                onClick={() => setShowModal(true)}
              />
            </div>
          )}
        <div className="h-full">
          {renderRequestTabs}
          <Card
            className={
              requestType === REQUEST_TYPES.AD_HOC
                ? "gen-card"
                : "gen-card mt-4"
            }
          >
            <RequestDataTable
              loading={loading}
              isDataAvailable={isDataAvailable}
              requests={requests}
              totalRecords={totalRecords}
              page={page}
              rows={rows}
              onPageChange={onPageChange}
              setShowModal={setShowModal}
              requestType={requestType}
            />
          </Card>
          <NewRequestModal
            showModal={showModal}
            setShowModal={setShowModal}
            hideRequestModal={hideRequestModal}
            refetch={refetch}
            requestType={requestType}
            parentTab={
              requestType === REQUEST_TYPES.ESCALATION
                ? REQUEST_TYPES.ESCALATION
                : null
            }
          />
        </div>
      </div>
    </Layout>
  );
};

Requests.propTypes = {
  requestType: PropTypes.string.isRequired,
};

export default Requests;
